import dragEnd from '@mailobj-browser/front/js/events/types/dragEnd.js'
import { rect } from '#utilities/js/fixed/fixed.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import href from '#utilities/js/ea/href.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import confirm from '#utilities/js/ea/confirm.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements as genericsElements } from '#components/generics/js/styles.js'
import { elements } from '../../../styles.js'
import { get } from '#utilities/js/ea/ajax.js'
import { rendered } from '@mailobj-browser/front/js/tree/tree.js'
import mouseOver from '@mailobj-browser/front/js/events/types/mouseOver.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const magnetsPositions = new WeakMap()

const onDragEnd = object(listener, {
  type: dragEnd,
  passive,
  task: async (
    magnet,
    event
  ) => {
    const { dataset, offsetLeft, offsetTop, parentNode } = magnet
    const { uid } = dataset
    const container = magnet.closest(`.${elements.fridge_container}`)
    const textarea = one('textarea', magnet)
    const { space, fridge } = container.dataset
    const { left, right, top, bottom } = rect(magnet)
    const { left: parentLeft, right: parentRight, top: parentTop, bottom: parentBottom } = rect(parentNode)
    let url

    if (parentTop > top || bottom > parentBottom || left < parentLeft || parentRight < right || event.clientX < parentLeft
      || event.clientY < parentTop || event.clientX > parentRight || event.clientY > parentBottom) {
      await deleteMagnet(magnet)
      return
    }

    if (textarea) {
      url = href('space/req_fridge', {
        act: 'modify',
        magnet_xpos: offsetLeft,
        magnet_ypos: offsetTop,
        magnet_text: textarea.value,
        space,
        uid,
        fridge
      })
    } else {
      url = href('space/req_fridge', {
        act: 'modify',
        magnet_xpos: offsetLeft,
        magnet_ypos: offsetTop,
        space,
        uid,
        fridge
      })
    }

    await get(url, { target: magnet })
    magnetsPositions.set(magnet, { x: offsetLeft, y: offsetTop })
  }
})

const deleteMagnet = async (magnet) => {
  const { dataset, style } = magnet
  const { uid, confirm: msg } = dataset
  const deleteButton = one('button[data-contract="contracts.space.mains.fridge.remove"]', magnet)
  const container = magnet.closest(`.${elements.fridge_container}`)
  const { space, fridge } = container.dataset

  const url = href('space/req_fridge', {
    act: 'delete',
    uid,
    space,
    fridge
  })

  const result = await confirm(msg, '', [deleteButton])

  if (result) {
    await get(url, { target: magnet })
    remove(magnet)
    magnetsPositions.delete(magnet)
  } else {
    const { x, y } = magnetsPositions.get(magnet)
    style.setProperty('--ea_utilities_calculated_left', `${x}px`)
    style.setProperty('--ea_utilities_calculated_top', `${y}px`)
  }
}

const onMouseOver = object(listener, {
  type: mouseOver,
  passive,
  task: (magnet) => {
    const container = magnet.closest(`.${elements.fridge_container}`)
    const buttons = one(`.${genericsElements.buttons}`, magnet)
    const { style } = buttons

    style.setProperty('display', 'flex')

    const { bottom } = rect(buttons)
    const { bottom: fridgeBottom } = rect(container)

    if (bottom > fridgeBottom) {
      style.setProperty('--top', 'unset')
      style.setProperty('--bottom', '0')
    }

    style.removeProperty('display')
  }
})

const onDelete = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: async (button) => {
    const magnet = button.closest(`.${elements.fridge_magnet}`)

    await deleteMagnet(magnet)
  }
})

export const removeMagnet = (button) => {
  onDelete.listen(button)
}

export default magnet => {
  const { parentNode } = magnet

  if (!magnetsPositions.has(magnet)) {
    queueMicrotask(async () => {
      if (await rendered(magnet, parentNode)) {
        const { offsetLeft, offsetTop } = magnet
        magnetsPositions.set(magnet, { x: offsetLeft, y: offsetTop })
      }
    })
  }

  onMouseOver.listen(magnet)
  onDragEnd.listen(magnet)
}
